
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memorial",
      function () {
        return require("private-next-pages/memorial.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memorial"])
      });
    }
  